import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/atoms/texts/label';
import { Button } from '@/components/molecules/buttons/button';
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';

const REFUSAL_COMMENT_MAX_LENGTH = 1000;

const RefuseCandidateDialog = ({ open, onOpenChange, onConfirm, loading, error }) => {
    const [t] = useTranslation('global');
    const [comment, setComment] = useState('');

    const trimmedComment = comment.trim();

    const handleOpenChange = (nextOpen) => {
        if (!nextOpen) setComment('');
        onOpenChange(nextOpen);
    };

    const handleConfirm = async () => {
        if (!trimmedComment) return;
        await onConfirm(trimmedComment);
        setComment('');
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        <Label message="management.onboarding.refuseDialog.title" size="h4" />
                    </DialogTitle>
                    <DialogDescription className="flex flex-col gap-4 py-4">
                        <Label message="management.onboarding.refuseDialog.description" />

                        <div className="flex flex-col gap-2">
                            <Label message="management.onboarding.refuseDialog.commentLabel" fontWeight="semibold" />
                            <Textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder={t('management.onboarding.refuseDialog.commentPlaceholder')}
                                rows={4}
                                maxLength={REFUSAL_COMMENT_MAX_LENGTH}
                                className="resize-none"
                            />
                            <Label size="small" color="grey" className="self-end">
                                {comment.length}/{REFUSAL_COMMENT_MAX_LENGTH}
                            </Label>
                        </div>

                        {error && <PrintErrorMessage error={error} />}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="sm:justify-start">
                    <Button
                        type="button"
                        style="ghost"
                        text="global.actions.cancel"
                        onClick={() => handleOpenChange(false)}
                    />
                    <div className="flex items-center justify-center">
                        {loading && <span className="loader" />}
                    </div>
                    <Button
                        style="fill"
                        text="management.onboarding.refuseDialog.confirm"
                        className="w-full"
                        onClick={handleConfirm}
                        disabled={!trimmedComment || loading}
                    />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default RefuseCandidateDialog;
